module.exports = __webpack_public_path__ + "img/EnumaGroupPhoto1600.401f19e4.jpg";